import { EnvConfig } from "@/shared/domain/types";

export const env: EnvConfig = {
  // Microservices URLs - 100% configurables desde variables de entorno
  API_URL_DOCUMENTOS: import.meta.env.VITE_API_URL_DOCUMENTOS,
  API_URL_GUIAS: import.meta.env.VITE_API_URL_GUIAS,
  API_URL_EXPORT_GUIAS: import.meta.env.VITE_API_URL_EXPORT_GUIAS,
  API_TIMEOUT: Number(import.meta.env.VITE_API_TIMEOUT),
  
  // App Info
  APP_NAME: import.meta.env.VITE_APP_NAME,
  APP_VERSION: import.meta.env.VITE_APP_VERSION,
  IS_DEV: import.meta.env.DEV,
  IS_PROD: import.meta.env.PROD,
  
  // OAuth2 Configuration
  OAUTH2_BASE_URL: import.meta.env.VITE_OAUTH2_BASE_URL,
  OAUTH2_CLIENT_ID: import.meta.env.VITE_OAUTH2_CLIENT_ID,
  OAUTH2_CLIENT_SECRET: import.meta.env.VITE_OAUTH2_CLIENT_SECRET,
  OAUTH2_REDIRECT_URI: import.meta.env.VITE_OAUTH2_REDIRECT_URI,
  OAUTH2_ENCRYPTION_KEY: import.meta.env.VITE_OAUTH2_ENCRYPTION_KEY,
  
  // Keycloak Configuration
  KEYCLOAK_BASE_URL: import.meta.env.VITE_KEYCLOAK_BASE_URL,
  KEYCLOAK_REALM: import.meta.env.VITE_KEYCLOAK_REALM,
  KEYCLOAK_ADMIN_CLIENT_ID: import.meta.env.VITE_KEYCLOAK_ADMIN_CLIENT_ID,
  KEYCLOAK_ADMIN_CLIENT_SECRET: import.meta.env.VITE_KEYCLOAK_ADMIN_CLIENT_SECRET,
  OAUTH_URL_LAMBDA: import.meta.env.VITE_OAUTH_URL_LAMBDA,
};